export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        name: entity.name || '',
        monthlyLimit: entity.monthlyLimit || '',
        dailyLimit: entity.dailyLimit || '',
        subsidyValue: entity.subsidyValue || 100,
        day1Allowed: entity.hasOwnProperty('day1Allowed') ? entity.day1Allowed : 'true',
        day2Allowed: entity.hasOwnProperty('day2Allowed') ? entity.day2Allowed : 'true',
        day3Allowed: entity.hasOwnProperty('day3Allowed') ? entity.day3Allowed : 'true',
        day4Allowed: entity.hasOwnProperty('day4Allowed') ? entity.day4Allowed : 'true',
        day5Allowed: entity.hasOwnProperty('day5Allowed') ? entity.day5Allowed : 'true',
        day6Allowed: entity.hasOwnProperty('day6Allowed') ? entity.day6Allowed : 'true',
        day7Allowed: entity.hasOwnProperty('day7Allowed') ? entity.day7Allowed : 'true',
    };
};
